import React from 'react';

function IncomeErrorMessage({id, className, errorMessage}) {
  return (
    <p id={id} className={className}>
      {errorMessage}
    </p>
  );
}

export default IncomeErrorMessage;
